import { Button, Code, HStack, Spinner, Stack, Textarea, useToast } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { jsonToYaml, yamlToJson } from "../../../fix-search/API"
import { ErrorToast } from "../Notifications/NotificationToast"

export const YamlEditSessionForm = ({
    session,
    handleSessionEdit,
    discard,
    notify
}) => {

    const [yamlValue, setYamlValue] = useState(null)
    const [loadingJson, setLoadingJson] = useState(false)

    const toast = useToast()

    useEffect(() => {
        const json = JSON.stringify(session)
        jsonToYaml(json, 'FixSessionCfg')
            .then((response) => {
                setYamlValue(response.data)
            })
            .catch(e => {
                toast({
                    position: 'top',
                    duration: null,
                    isClosable: true,
                    render: ({onClose}) => (
                        <ErrorToast
                            title={'Failed to build YAML config'}
                            onClose={onClose}
                        >
                            <Code width='480px' padding={3} borderRadius={5}>
                                {e?.response?.data}
                            </Code>
                        </ErrorToast>
                    )
                })
                console.log(e)
                console.log(e?.response)
                console.log(e?.toJSON())
                notify({
                    level: 'ERROR',
                    message: `Failed to build YAML config: ${e?.message}`,
                    stackTrace: e?.stack,
                    responseData: e?.response?.data
                })
                discard()
            })
    }, [])

    const handleChange = (e) => {
        setYamlValue(e.target.value)
    }

    const applyChanges = () => {
        setLoadingJson(true)
        yamlToJson(yamlValue, 'FixSessionCfg')
            .then((response) => {
                handleSessionEdit(response.data)    
            })
            .catch(e => {
                toast({
                    position: 'top',
                    duration: null,
                    isClosable: true,
                    render: ({onClose}) => (
                        <ErrorToast
                            title={'Failed to build YAML config'}
                            onClose={onClose}
                        >
                            <Code width='480px' padding={3} borderRadius={5}>
                                {e?.response?.data}
                            </Code>
                        </ErrorToast>
                    )
                })
                console.log(e)
                console.log(e?.response)
                console.log(e?.toJSON())
                setLoadingJson(false)
            })
    }
    
    return (
        <Stack spacing={4}>
            {yamlValue === null &&
                <Spinner alignSelf='center'/>
            }
            {yamlValue !== null && 
                <>
                {loadingJson &&
                    <Spinner
                        position='absolute'
                        top='50%'
                        left='50%'
                    />
                }
                <Textarea
                    isDisabled={loadingJson}
                    padding={3}
                    value={yamlValue}
                    onChange={handleChange}
                    fontFamily='var(--code-font-family)'
                    height='70vh'
                    whiteSpace='pre'
                    backgroundColor='var(--chakra-colors-input)'
                    border='none'
                    fontSize={14}
                />
                <HStack justifyContent='flex-end' spacing={4}>
                    <Button onClick={discard} variant='outline'>
                        Discard
                    </Button>
                    <Button onClick={applyChanges}>
                        Apply
                    </Button>
                </HStack>
                </>
            }
        </Stack>
    )
}